import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points } from '@styles';

export const SectionNumber = ({ number = '', text = '', textColor = Colors.main_dark }) => {
  return (
    <View>
      {number.length > 0 && <Number>{number}</Number>}
      <Text color={textColor}>{text}</Text>
    </View>
  );
};

const View = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 20px;

  @media ${Points.tablet_landscape} {
    justify-content: flex-start;
  }
`;
const Number = styled.div`
  min-width: 28px;
  height: 28px;
  background-color: ${Colors.main_blue};
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.white};
  margin-right: 6px;
  padding: 4px;
`;
const Text = styled.h2`
  text-transform: uppercase;
  color: ${({ color }) => color};
  font-weight: 400;
  font-size: 14px;
  line-height: 1.1;
  letter-spacing: 7%;
`;
